<template>
  <div>
    <heading size="h1" style-size="h4" class="mb-5">My Experiences</heading>
    <vs-table ref="table" :data="incompleteExperiences">
      <template slot="thead">
        <vs-th sort-key="name" scope="col" width="5%">#</vs-th>
        <vs-th sort-key="name" scope="col" width="15%">Work Experience</vs-th>
        <vs-th sort-key="name" scope="col" width="15%">Type</vs-th>
        <vs-th sort-key="email" scope="col" width="50%">Date Started</vs-th>
        <vs-th scope="col" width="10%">Action</vs-th>
      </template>

      <template>
        <tbody>
          <vs-tr
            :data="experience"
            :key="indextr"
            v-for="(experience, indextr) in incompleteExperiences"
          >
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td scope="row">{{ experience.vje.name }}</vs-td>
            <vs-td>
              {{ experience.type == 1 ? 'Virtual' : 'Real world' }}
            </vs-td>
            <vs-td>{{ experience.date_started_formatted }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <button
                class="btn btn-primary btn-size-small"
                role="link"
                :aria-label="`Continue ${experience.vje.name} experience`"
                @click="continueExperience(experience.id)"
              >
                Continue
              </button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import store from '@/store/store';
import router from '@/router/router';

export default {
  computed: {
    incompleteExperiences() {
      return store.getters['authStudent/experiences'].filter((e) => {
        return !e.completed;
      });
    },
  },
  methods: {
    continueExperience(id) {
      store.commit('authStudent/setActiveExperienceID', id);
      router.push('/student/work-experience-router');
    },
  },
};
</script>
